import { render, staticRenderFns } from "./PropertyValuationView.vue?vue&type=template&id=295a7ffe&"
import script from "./PropertyValuationView.vue?vue&type=script&lang=js&"
export * from "./PropertyValuationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports